import styled from 'styled-components';

import { Loader } from '@components';
import Input from '@components/Input';
import Select from '@components/Select';
import OrderStatus from '@components/CRM/Orders/OrderStatus';

const Panel = styled.section`
  background: #fff;
  border: 1px solid #dfe2e6;
  border-radius: 7px;
  box-shadow: 0 1px 4px rgba(24, 35, 48, 0.05);
`;

export const Page = styled.main`
  align-self: stretch;
  background: #eef0f2;
  display: grid;
  gap: 12px;
  grid-template-rows: auto minmax(0, 1fr);
  height: 100%;
  min-height: 650px;
  padding: 12px;
  width: 100%;
`;

export const Topbar = styled(Panel)`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;

  > div:first-child {
    display: grid;
    gap: 3px;
  }
`;

export const Title = styled.h1`
  font-size: 21px;
  line-height: 26px;
  margin: 0;
`;

export const Muted = styled.div`
  color: #919499;
  font-size: 12px;
  line-height: 17px;
`;

export const Content = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: 345px minmax(650px, 1fr);
  min-height: 0;
`;

export const OrderList = styled(Panel)`
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
  min-height: 0;
  overflow: hidden;
`;

export const Filters = styled.div`
  display: grid;
  gap: 8px;
  padding: 12px;
`;

export const SearchInput = styled(Input)`
  border-color: #d9dce1;
  font-size: 13px;
  height: 36px;
  padding: 0 10px;
  width: 100%;

  &:focus {
    border-color: #007aff;
    outline: none;
  }
`;

export const StatusSelect = styled(Select)`
  border: 1px solid #d9dce1;
  width: 100%;
`;

export const ListBody = styled.div`
  border-top: 1px solid #e1e3e6;
  min-height: 0;
  overflow: hidden;
  position: relative;
`;

export const ListError = styled.div`
  background: #fff1f0;
  color: #b42318;
  font-size: 12px;
  left: 0;
  padding: 10px 12px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
`;

export const NextPageLoader = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const OrderRow = styled.button<{ $active: boolean }>`
  background: ${({ $active }) => ($active ? '#f1f7ff' : '#fff')};
  border: 0;
  border-bottom: 1px solid #eceef0;
  border-left: 3px solid
    ${({ $active }) => ($active ? '#007aff' : 'transparent')};
  cursor: pointer;
  display: grid;
  font-family: inherit;
  gap: 7px;
  padding: 12px 13px;
  text-align: left;
  width: 100%;

  &:hover {
    background: ${({ $active }) => ($active ? '#f1f7ff' : '#f7f9fb')};
  }
`;

export const RowTop = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const OrderNumber = styled.strong`
  color: #007aff;
  font-size: 13px;
`;

export const CompactStatus = styled(OrderStatus)`
  font-size: 11px;
  height: 21px;
  line-height: 21px;
  margin: 0;
  min-width: auto;
`;

export const HotelName = styled.strong`
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RowBottom = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;

  strong {
    font-size: 15px;
  }

  span {
    color: #919499;
    font-size: 11px;
  }
`;

export const EmptyList = styled.div`
  display: grid;
  gap: 5px;
  justify-items: center;
  padding: 44px 20px;
  text-align: center;
`;

export const ListLoader = styled(Loader)`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 220px;
  width: 100%;
`;

export const DetailsPanel = styled(Panel)`
  min-width: 0;
  overflow: hidden;
`;

export const DetailsLoader = styled(Loader)`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 420px;
  width: 100%;
`;

export const EmptyDetails = styled.div`
  align-content: center;
  display: grid;
  gap: 7px;
  height: 100%;
  justify-items: center;
  padding: 30px;
  text-align: center;
`;
